{
  "eyebrow": "Abrechnung & Zahlung",
  "title": "Fast geschafft.",
  "sub": "Weiter zur sicheren Kasse, um Ihre 30-tägige Testphase zu starten. Heute wird Ihnen nichts berechnet.",
  "summary": {
    "plan": "Tarif",
    "cycle": "Abrechnungszyklus",
    "users": "Nutzer",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Fahrzeuge",
    "total": "Geschätzte Gesamtkosten / Monat",
    "vttOn": "Inbegriffen"
  },
  "secureNote": "Sichere Kasse via Stripe · 30-tägige Testphase · Jederzeit kündbar",
  "continue": "Weiter zu Stripe",
  "submitting": "Stripe wird geöffnet…",
  "canceled": {
    "title": "Zahlung abgebrochen",
    "sub": "Es wurde keine Belastung vorgenommen. Versuchen Sie es erneut oder kontaktieren Sie uns.",
    "retry": "Erneut versuchen"
  },
  "promo": {
    "toggle": "Haben Sie einen Aktionscode?",
    "placeholder": "Aktionscode",
    "apply": "Anwenden",
    "chip": "{{percent}}% Rabatt",
    "remove": "Aktionscode entfernen",
    "errorGeneric": "Code konnte nicht geprüft werden. Bitte erneut versuchen."
  },
  "errors": {
    "generic": "Kasse konnte nicht gestartet werden. Bitte erneut versuchen."
  },
  "totalUnavailable": "Preiskatalog nicht verfügbar. Erneut versuchen, um die aktuellen Preise zu laden."
}
